import { Helper } from '../Helper';
export class ArrMapHelper extends Helper {
    constructor(options) {
        super();
        this.map = options.map;
        this.withIndex = options.withIndex || false;
    }
    emit(sb, node, options) {
        if (this.withIndex) {
            sb.emitSysCall(node, 'Neo.Iterator.Create');
            sb.emitPushInt(node, 0);
            sb.emitOp(node, 'NEWARRAY');
            sb.emitHelper(node, options, sb.helpers.rawIteratorReduce({
                each: (innerOptions) => {
                    sb.emitOp(node, 'ROT');
                    sb.emitOp(node, 'ROT');
                    sb.emitOp(node, 'SWAP');
                    this.map(innerOptions);
                    sb.emitOp(node, 'OVER');
                    sb.emitOp(node, 'SWAP');
                    sb.emitOp(node, 'APPEND');
                },
            }));
        }
        else {
            sb.emitSysCall(node, 'Neo.Enumerator.Create');
            sb.emitPushInt(node, 0);
            sb.emitOp(node, 'NEWARRAY');
            sb.emitHelper(node, options, sb.helpers.rawEnumeratorReduce({
                each: (innerOptions) => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'SWAP');
                    this.map(innerOptions);
                    sb.emitOp(node, 'APPEND');
                },
            }));
        }
    }
}

//# sourceMappingURL=ArrMapHelper.js.map
